import urlDataNames from '@/helpers/urlDataNames.json';

// TODO: Reavaliate if migrations are the best option.
// This could be done way easier on URL ui type mounted.
const isOldUrl = ([key, value]) =>
  typeof value !== 'undefined' &&
  urlDataNames.includes(key) &&
  (typeof value === 'string' || // Check if it's legacy TODO: stop setting default as string
    value.type === 'pageAnchor' || // Check if it's pageAnchor, as now every anchor is an pageAnchor
    (value.type === 'externalLink' &&
      typeof value.openInNewTab === 'undefined') || // Check if the external link has none openInNewTab property
    (value.type === 'anchor' && typeof value.value === 'string')); // Check if the anchor isn't an object with page and hash

const find = (data) =>
  Object.entries(data)
    // TODO: Migrate repeatable items individually
    // If it is an array, check if any of its repeatable children has any old url ui type
    .filter(([key, value]) =>
      Array.isArray(value)
        ? value.some((repeatable) => {
            if (!repeatable || typeof repeatable !== 'object') {
              return false;
            }
            return Object.entries(repeatable).some(isOldUrl);
          })
        : isOldUrl([key, value]),
    );

export function target() {
  return find(this.data).length;
}

// TODO: Reavaliate the type property.
// Wouldn't it be better if there was just the main object with the properties
// url, page and anchor to define its type?
function migrateUrlFields([key, value = { type: 'externalLink', value: '' }]) {
  if (typeof value === 'string') {
    this[key] = {
      type: 'externalLink',
      value,
    };
  }

  if (this[key].type === 'externalLink') {
    // TODO: Consider promo header, which has three different openInNewTab in its data
    const [tabKey = '', externalOpenInNewTab = true] =
      Object.entries(this).find(([innerKey]) =>
        innerKey.toLowerCase().includes('openinnewtab'),
      ) || [];

    this[key].openInNewTab = externalOpenInNewTab;
    delete this[tabKey];
  }

  if (this[key].type === 'anchor') {
    this[key] = {
      type: 'anchor',
      value: {
        // TODO: Name this better
        // Extract the hash from the value object, there's no spread so it doesn't polute with type
        anchor: value.value,
        page: '',
      },
    };
  }

  if (this[key].type === 'pageAnchor') {
    this[key].type = 'anchor';
  }
}

export function migrate() {
  const urlFieldsEntries = find(this.data);

  urlFieldsEntries.forEach(([key, value]) => {
    // TODO: Migrate repeatable items individually
    // If it is array, iterate through it, then filter its children
    // object entries so, then, iterate  through it to migrate each
    if (Array.isArray(value)) {
      value.forEach((child, childIndex) => {
        Object.entries(child)
          .filter(isOldUrl)
          .forEach(([childKey, childValue]) => {
            migrateUrlFields.call(this.data[key][childIndex], [
              childKey,
              childValue,
            ]);
          });
      });
    } else {
      migrateUrlFields.call(this.data, [key, value]);
    }
  });
}
